<template>
  <tr>
    <td data-label="Hazard Location">
      {{ ohsLocation.location }}
    </td>
    <td class="button-2 text-center">
      <button class="my-2 btn btn-warning" @click="editLocation()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteLocation()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  export default {
    name: 'OhsLocationRow',
    components: {
      Dropdown
    },
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      ohsLocation () {
        return {
          Properties: [],
          ...this.object
        }
      }
    },
    methods: {
      editLocation () {
        this.$emit('edit', { permalink: 'editOhsLocation', uuid: this.ohsLocation.uuid })
      },
      deleteLocation () {
        this.$emit('deleteObject', { permalink: 'deleteOhsLocation', uuid: this.ohsLocation.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/OhsLocation.vue